import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchHkbkListComponent } from './research-hkbk-list/research-hkbk-list.component';
import { ResearchHkbkCreateComponent } from './research-hkbk-create/research-hkbk-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: ResearchHkbkListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: ResearchHkbkCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'research-hkbk-create/:id',
        component: ResearchHkbkCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResearchHkbkRoutingModule { }
